import Vue from "vue";
import DOMPurify from "dompurify";
import { mapGetters, mapState } from "vuex";

Vue.mixin({
	data(){
        return {
            zones: [
                // { title: "Lobby", slug: "lobby", wellness: "lobby", inMap: false },
                { title: "Lobby", slug: "lobby", wellness: "lobby_flat", media: "lobby_flat", inMap: false },
                { title: "Lobby", slug: "lobby_m", wellness: "lobby_flat_m", media: "lobby_flat_m", inMap: false },
                { title: "Entrance", slug: "entrance", wellness: "interior", media: "interior", inMap: true },
                { title: "Peacetopia", slug: "peacetopia", wellness: "mental", media: "mental_01", inMap: true },
                { title: "Groove Together", slug: "groove_together", wellness: "family", media: "family_01", inMap: true },
                { title: "Orchard Pop", slug: "orchard_pop", wellness: "physical", media: "physical_01", inMap: true },
                { title: "The Wealth Symphony", slug: "the_wealth_symphony", wellness: "financial", media: "financial_01", inMap: true },
                { title: "Hardrock HQ", slug: "hardrock", wellness: "workplace", media: "workplace_01", inMap: true },
            ],

            lobbyMap: {
                title: "Tunetopia Map",
                eyebrow: "MYWELLNESS FIESTA 2026",
                image: "/static/images/map/tunetopia.jpg",
                imageMobile: "/static/images/map/tunetopia.jpg",
                imageW: 7512,
                imageH: 5643,
                iconPath: "/static/images/map",
                descPath: "/static/images/map/desc",
                fit: "slice",
                align: "xMidYMax",
                focus: {
                    desktop: { x: 14.07, y: 10.54, width: 72.46, height: 72.46 },
                    desktopActive: { x: 14.07, y: 10.54, width: 72.46, height: 72.46 },
                    mobile: { x: 6.82, y: 11.04, width: 86.96, height: 86.96 },
                    mobileActive: { x: 6.82, y: 11.04, width: 86.96, height: 86.96 },
                },
                inset: {
                    desktop: { top: "0", right: "0", bottom: "0", left: "0" },
                    desktopActive: { top: "0", right: "0", bottom: "0", left: "0" },
                    mobile: { top: "0", right: "0", bottom: "92px", left: "0" },
                    mobileActive: { top: "0", right: "0", bottom: "92px", left: "0" },
                },
                iconSize: 3.7,
                iconSizeMobile: 4.62,
                overlayColor: "#ffffff",
                overlayOpacity: 0.5,
                outlineColor: "#DF2F3B",
                skyFrom: "#04246e",
                skyVia: "#08338c",
                skyTo: "#144db1",
                panel: {
                    desktop: { top: "6%", left: "0", right: "0" },
                    mobile: { top: "4%", left: "0", right: "0" },
                },
                goto: {
                    desktop: { bottom: "11%", left: "50%" },
                    mobile: { bottom: "110px", left: "50%" },
                },
                areas: [
                    {
                        key: "physical",
                        slug: "orchard_pop",
                        icon: "physical",
                        desc: "<b>Get moving and feel the beat!</b><br>Discover fun ways to stay active, energised and well.",
                        descImage: "",
                        x: 41.99,
                        y: 59.69,
                        area: [[42.09, 54.57], [41.99, 55.47], [43.44, 54.61], [44.3, 56.01], [45.17, 54.9], [47.39, 56.09], [50.22, 55.84], [50.28, 58.02], [44.8, 60.23], [44.71, 63.89], [43.29, 67.13], [39.0, 65.12], [38.26, 65.82], [35.83, 65.04], [33.86, 66.59], [33.49, 64.34], [31.95, 62.82], [32.56, 60.85], [33.36, 61.01], [34.87, 58.55], [36.02, 58.8], [38.97, 55.52], [41.59, 55.43], [42.06, 54.61]],
                    },
                    {
                        key: "mental",
                        slug: "peacetopia",
                        icon: "mental",
                        desc: "<b>Slow down and tune in!</b><br>Find simple ways to recharge, reset and care for your mind.",
                        descImage: "",
                        x: 57.83,
                        y: 58.72,
                        area: [[55.21, 53.75], [57.21, 54.2], [57.64, 55.19], [59.46, 54.61], [60.94, 56.3], [61.56, 55.43], [61.93, 56.91], [62.79, 56.3], [62.79, 57.49], [63.84, 57.98], [64.73, 57.44], [67.5, 61.96], [61.06, 61.51], [60.88, 62.33], [57.89, 62.82], [56.59, 64.67], [56.04, 60.28], [50.34, 57.98], [50.37, 55.68], [54.5, 55.6], [55.18, 53.79]],
                    },
                    {
                        key: "family",
                        slug: "groove_together",
                        icon: "family",
                        desc: "<b>Good vibes are better together!</b><br>Make time to connect, share and strengthen the bonds that matter.",
                        descImage: "",
                        x: 62.88,
                        y: 65.06,
                        area: [[63.15, 61.31], [66.94, 62.42], [66.64, 63.41], [67.04, 63.69], [67.31, 63.57], [67.5, 63.08], [68.21, 63.53], [68.33, 64.1], [68.11, 64.51], [67.87, 64.43], [68.15, 64.64], [67.99, 65.01], [68.39, 65.5], [68.82, 66.89], [69.35, 67.59], [69.35, 68.37], [66.88, 70.26], [62.04, 69.85], [60.5, 69.07], [58.35, 68.78], [57.17, 68.21], [57.36, 66.4], [56.65, 64.68], [57.51, 64.35], [57.27, 63.98], [57.88, 62.91], [61.0, 62.34], [61.09, 61.52], [63.12, 61.35]],
                    },
                    {
                        key: "workplace",
                        slug: "hardrock",
                        title: "Hardrock HQ",
                        icon: "workplace",
                        desc: "<b>Rock your workday!</b><br>Find simple ways to stay focused, connected and well at work.",
                        descImage: "",
                        x: 60.61,
                        y: 73.32,
                        area: [[57.12, 68.29], [58.36, 68.9], [59.28, 68.9], [60.48, 69.19], [61.9, 69.93], [66.89, 70.34], [66.46, 70.75], [66.49, 70.91], [67.36, 72.06], [67.57, 72.06], [68.53, 73.17], [68.5, 73.99], [63.97, 78.05], [61.01, 78.18], [59.19, 79.41], [58.2, 79.86], [55.49, 76.21], [53.03, 71.82], [54.51, 71.16], [55.65, 70.38], [56.69, 69.19], [57.09, 68.33]],
                    },
                    {
                        key: "financial",
                        slug: "the_wealth_symphony",
                        icon: "financial",
                        desc: "<b>Make your money work in harmony!</b><br>Build healthy financial habits and plan for what's ahead.",
                        descImage: "",
                        x: 37.2,
                        y: 70.23,
                        area: [[35.85, 65.06], [38.22, 65.84], [38.99, 65.15], [43.31, 67.16], [43.65, 68.59], [44.51, 69.86], [45.83, 70.93], [47.34, 71.63], [46.17, 73.8], [42.35, 77.74], [40.38, 77.66], [39.76, 76.8], [38.78, 76.72], [37.82, 75.81], [36.4, 75.86], [35.39, 74.91], [34.03, 74.71], [32.03, 72.16], [32.06, 71.47], [32.49, 70.85], [32.06, 70.07], [32.03, 69.37], [32.43, 68.8], [32.24, 68.26], [32.55, 68.1], [32.71, 67.65], [32.98, 67.77], [33.35, 67.53], [33.85, 66.58], [35.82, 65.11]],
                    },
                    {
                        key: "main",
                        slug: null,
                        title: "MyWellness Main Stage",
                        icon: "main",
                        desc: "<b>Your wellness journey starts here!</b><br>Explore Tunetopia, discover what's happening and tune in to better wellbeing.",
                        descImage: "",
                        x: 50.31,
                        y: 62.0,
                        area: [[50.13, 58.03], [51.64, 58.36], [53.0, 59.75], [56.02, 60.33], [55.98, 63.98], [56.91, 65.29], [57.28, 66.65], [57.16, 67.96], [56.51, 69.31], [55.34, 70.5], [53.43, 71.53], [52.04, 71.9], [51.05, 71.04], [50.07, 70.91], [49.36, 71.2], [48.8, 71.94], [45.91, 70.91], [43.94, 69.03], [43.47, 67.96], [43.35, 66.69], [43.78, 65.17], [44.77, 63.86], [44.55, 61.11], [44.8, 60.29], [47.82, 59.75], [48.8, 58.6], [50.1, 58.07]],
                    },
                ],
            },

            streakMap: {
                5: "First Beat",
                10: "Finding Your Rhythm",
                15: "On Stage",
                20: "Crowd Favourite",
                30: "Festival Headliner",
                39: "Encore Champion",
            },

            rankMap: {
                0: "Festival Guest",
                500: "Music Explorer",
                1000: "Beat Chaser",
                1500: "Stage Performer",
                2200: "Crowd Favourite",
                3000: "Festival Headliner",
                5000: "Music Legend",
            },

            streakContentMap: {
                0: {
                    title: "Daily Check-In",
                    heading: "Keep the beat going!",
                    desc: "You're checked in for today.<br>Come back tomorrow to keep your streak alive!",
                    point: 10,
                },
                5: {
                    heading: "You've found the beat!",
                    desc: "5 days strong &mdash; You've found your rhythm! Keep the streak going.",
                    point: 20,
                },
                10: {
                    heading: "You're in the groove!",
                    desc: "10 days strong &mdash; keep that streak going!",
                    point: 40,
                },
                15: {
                    heading: "You're on stage!",
                    desc: "15 days and counting &mdash; keep showing up!",
                    point: 60,
                },
                20: {
                    heading: "The crowd loves you!",
                    desc: "You've hit 20 days &mdash; keep the good vibes going!",
                    point: 80,
                },
                30: {
                    heading: "You're headlining!",
                    desc: "30 days strong &mdash; the ultimate encore is within reach!",
                    point: 120,
                },
                39: {
                    heading: "Encore! Encore!",
                    desc: "You kept the beat going all Festival long. What a finish!",
                    point: 180,
                },
            },
        }
    },
	computed: {
		...mapState({
			user: state => state.auth.user,
            winW: state => state.context.winW,
            winH: state => state.context.winH,
		}),
		...mapGetters({
			tokenHeader: "auth/tokenHeader",
		}),
        mapZones(){
            return this.zones.filter(zone => zone.inMap);
        },
        roomItems(){
            return this.zones.reduce((accumulatedZones, zone) => {
                accumulatedZones[zone.slug] = zone.title;
                return accumulatedZones;
            }, {});
        }
	},
	methods: {
        slugToText(item){
            return _.startCase(_.toLower(item.replace(/_/g, " ")));
        },
        roomToWellness(room){
            const item = _.find(this.zones, { slug: room });
            return item.wellness;
        },
        wellnessToRoom(wellness){
            const item = _.find(this.zones, { wellness });
            return item.slug;
        },
        wellnessToMedia(wellness){
            const item = _.find(this.zones, { wellness });
            return item?.media || wellness;
        },
        formattedAssetUrl(item){
            return `${ item }?v=${ process.env.assetVersion }`;
        },
        hashData(item){
            return this.$md5(`${ this.user?.id }${ item }`);
        },
        sanitizeText(item){
            // return DOMPurify.sanitize(item, { USE_PROFILES: { html: true } });
            return DOMPurify.sanitize(item, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        },
        getUserState(item){
            const reached = [39, 30, 20, 15, 10, 5].find(m => item >= m);
            return reached ? this.streakMap[reached] : '';
            // if(!item) return "No Rank";
            // return _.upperFirst(item);

        },
        getStreakContent(streak){
            const milestone = this.streakContentMap[streak] ? streak : 0;
            return {
                ...this.streakContentMap[0],
                ...this.streakContentMap[milestone],
                ...milestone && { title: this.streakMap[milestone] },
            };
        },
        getUserRank(points){
            const milestones = Object.keys(this.rankMap).map(Number).sort((a, b) => b - a);
            const reached = milestones.find(m => (points || 0) >= m);
            return this.rankMap[reached ?? milestones[milestones.length - 1]];
        },
        getUserRankProgress(points){
            const milestones = Object.keys(this.rankMap).map(Number).sort((a, b) => a - b);
            const max = milestones[milestones.length - 1];
            return Math.min(100, Math.max(0, ((points || 0) / max) * 100));
        },
        getUserRankImage(points){
            const milestones = Object.keys(this.rankMap).map(Number).sort((a, b) => b - a);
            const reached = milestones.find(m => (points || 0) >= m);
            return this.getUserRankIcon(reached ?? milestones[milestones.length - 1]);
        },
        getUserRankIcon(milestone){
            const milestones = Object.keys(this.rankMap).map(Number).sort((a, b) => a - b);
            return this.formattedAssetUrl(`/static/images/avatar/rankIcons/${ milestones.indexOf(Number(milestone)) }.png`);
        },
        onHandleApiError(err){
            const message = err?.response?.data?.message || err?.message || "Error";
            return this.$swal({
                icon: "error",
                title: message
            }).then(result => {
                if(["Invalid User", "Invalid Token"].includes(message)){
                    this.$store.dispatch("auth/onLogoutUser");
                }else if(typeof callback === "function"){
                    callback();
                } 
            });
        },
        showErrorSwal(err, callback){
            return this.$swal({
                icon: "error",
                title: err?.response?.data?.message || err?.message || "Error",
            }).then(result => {
                if(typeof callback === "function") callback();
            });
        },
		showConfirmSwal(text, confirmButtonText = "Yes"){
			return this.$swal({
			    title: "Are you sure?", 
			    icon: "warning",
			    showCancelButton: true,
			    confirmButtonColor: "#007bff",
			    cancelButtonColor: "#d33",
			    text, confirmButtonText
			});
		},
        onTriggerGA(data){
            console.log(data);
            if(typeof gtag !== "undefined"){
                gtag("event", "click", data);
            }
        },
        onHandleTriggerAnalytics(action){
            this.$store.dispatch('auth/onTriggerAnalytics', { action, event: "click_event", route: this.$route.path });
        },
	}
})